import { render, staticRenderFns } from "./HorizontalCard.vue?vue&type=template&id=84ccc94e&"
import script from "./HorizontalCard.vue?vue&type=script&lang=js&"
export * from "./HorizontalCard.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports